import { useEffect, useState } from "react";
import { ApolloError, NetworkStatus, useQuery } from "@apollo/client";
import { GET_RESOURCES_COUNT } from "./ResourcesApi";
import {
  filterEntityEnum,
  toCatalogContext,
  type FilterEntity,
} from "../AppView/FilterManagement/filterEntity";
import type { SelectedScope } from "../types/scope";

interface UseResourcesCountersOptions {
  selectedScope?: SelectedScope | null;
  scopeToExecute?: string | null;
  filterToExecute?: string | null;
  filterType?: FilterEntity;
  filterFieldsToOverride?: string[] | null;
  shouldSkip?: boolean;
}

interface ResourcesCountQueryData {
  resources_count?: {
    total_count?: number | null;
  } | null;
}

export interface ResourcesCountData {
  resourcesCounterLoading: boolean;
  resourcesCounterError?: ApolloError;
  count: number | null;
  refetchResourcesCounterData: () => void;
}

interface UseResourcesCountersReturn {
  resourcesCountData: ResourcesCountData;
}

const useResourcesCounters = ({
  selectedScope,
  scopeToExecute,
  filterToExecute,
  filterType = filterEntityEnum.RESOURCE,
  filterFieldsToOverride = null,
  shouldSkip = true,
}: UseResourcesCountersOptions): UseResourcesCountersReturn => {
  const [resourcesCount, setResourceCount] = useState<number | null>(null);
  // const [dataSourcesCount, setDataSourcesCount] = useState(null);

  const filtersConfig = {
    scopesjson: scopeToExecute,
    filtersjson: filterToExecute,
    scopesid: selectedScope?.value?.id,
    filters_fields_to_override: filterFieldsToOverride,
  };

  // const {
  //   loading: datasourceCounterLoading,
  //   error: datasourceCounterError,
  //   data: dataSourcesCounterData,
  // } = useQuery(GET_DATA_SOURCES_COUNT, {
  //   variables: {
  //     filters_config: filtersConfig,
  //   },
  //   skip: !selectedScope?.value?.id && !scopeToExecute,
  // });

  const {
    loading: resourcesCounterLoading,
    error: resourcesCounterError,
    data: resourcesCounterData,
    refetch: refetchResourcesCounterData,
    networkStatus: resourcesCounterNetworkStatus,
  } = useQuery<ResourcesCountQueryData>(GET_RESOURCES_COUNT, {
    variables: {
      filters_config: filtersConfig,
      filters_context: toCatalogContext(filterType),
    },
    skip:
      shouldSkip &&
      ((!selectedScope?.value?.id && !scopeToExecute) || !filterToExecute),
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    // if (dataSourcesCounterData) {
    //   setDataSourcesCount(
    //     dataSourcesCounterData?.datasources_count?.total_count
    //   );
    // }
    if (resourcesCounterData) {
      setResourceCount(
        resourcesCounterData?.resources_count?.total_count ?? null
      );
    }
  }, [resourcesCounterData]);

  return {
    // dataSourcesCountData: {
    //   datasourceCounterLoading:
    //     datasourceCounterLoading ||
    //     (dataSourcesCount !== 0 &&
    //       !dataSourcesCount &&
    //       !datasourceCounterLoading &&
    //       !datasourceCounterError),
    //   datasourceCounterError,
    //   count: dataSourcesCount,
    // },
    resourcesCountData: {
      resourcesCounterLoading:
        resourcesCounterLoading ||
        (resourcesCount !== 0 &&
          !resourcesCount &&
          !resourcesCounterLoading &&
          !resourcesCounterError) ||
        resourcesCounterNetworkStatus === NetworkStatus.refetch,
      resourcesCounterError,
      count: resourcesCount,
      refetchResourcesCounterData,
    },
  };
};

export default useResourcesCounters;
